import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Row, Col, Pagination} from 'react-bootstrap'
import {matchMedia} from '../../core/browser'
import {linkFinder} from '../../core/links'
import {USER_STREAM_LOADED, loadUserStream} from '../actions'
import UserCard from './UserCard'
import UpdateUserModal from './UpdateUserModal'
import UpdateLoginModal from './UpdateLoginModal'
import AssociateDissociateUserFromAgencyModal from './AssociateDissociateUserFromAgencyModal'
import AssociateDissociateUserFromPatrimonyModal from './AssociateDissociateUserFromPatrimonyModal'
import DisableUserModal from './DisableUserModal'
import DowngradeExecutiveToPatrimonyManagerModal from './DowngradeExecutiveToPatrimonyManagerModal'
import UserConfigsModal from './UserConfigsModal'
import style from './UserStream.less'

const PAGE_SIZE = 20

function modalName(result) {
    switch (result) {
        case 'configs':
            return 'UserConfigsModal'
        case 'UpdateUser':
            return 'UpdateUserModal'
        case 'UpdateLogin':
            return 'UpdateLoginModal'
        case 'AssociateDissociateUserFromAgency':
            return 'AssociateDissociateUserFromAgencyModal'
        case 'AssociateDissociateUserFromPatrimony':
            return 'AssociateDissociateUserFromPatrimonyModal'
        case 'DisableUser':
            return 'DisableUserModal'
        case 'DowngradeExecutiveToPatrimonyManager':
            return 'DowngradeExecutiveToPatrimonyManagerModal'
        default:
            return null
    }
}

class UserStream extends Component {
    static propTypes = {
    	stream: PropTypes.array.isRequired,
        range: PropTypes.object.isRequired
    }

    constructor(props) {
        super(props)

        this.state = {
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.stream != this.props.stream) {
            const {stream} = nextProps
            const {activeUser} = this.state
            
            const nextActiveUser = stream.find((u) => u.uid == (activeUser && activeUser.uid))
            this.setState({activeUser: nextActiveUser})
        }
    }

    _open(event, result, activeUser) {
        event.preventDefault()

        const opened = modalName(result)
        this.setState({opened, activeUser})
    }

    _close(event, result) {
        if (event) {
            event.preventDefault()
        }

        const opened = modalName(result)
        this.setState({opened})
    }

    _paginate(selectedEvent) {
        const {dispatch} = this.props

        const pageActive = selectedEvent.eventKey
        const offset = (pageActive - 1) * PAGE_SIZE
        const limit = offset + PAGE_SIZE - 1

        dispatch(loadUserStream({range: {offset, limit}}))
    }

    render() {
    	const {stream, range} = this.props
        const {opened, activeUser} = this.state

        const pageCount = Math.ceil(range.count / PAGE_SIZE)
        const pageActive = Math.floor(range.offset / PAGE_SIZE) + 1

        return (
        	<div>
                <Row>
        		{stream.map((user) => (
                    <Col
                        key={user.uid}
                        sm={4}>
                        <UserCard
                            user={user}
                            onSubmit={(e, r) => this._open(e, r, user)} />
                    </Col>
                ))}
                </Row>
                <div className={style.pagination}>
                    <Pagination prev next first last ellipsis
                        items={pageCount}
                        maxButtons={matchMedia('sm') && 5 || 4}
                        activePage={pageActive}
                        onSelect={(e, se) => this._paginate(se)} />
                </div>
                {activeUser && activeUser._links.find(linkFinder('configs')) && (
                    <UserConfigsModal
                        show={opened == 'UserConfigsModal'}
                        onHide={(e, r) => this._close(e, r)}
                        user={activeUser}/>
                )}
                {activeUser && activeUser._links.find(linkFinder(['UpdateUser', 'DisableUser', 'DowngradeExecutiveToPatrimonyManager'])) && (
                    <UpdateUserModal
                        show={opened == 'UpdateUserModal'}
                        onHide={(e, r) => this._close(e, r)}
                        user={activeUser}/>
                )}
                {activeUser && activeUser._links.find(linkFinder(['UpdateLogin', 'sendActivationEmailDemand'])) && (
                    <UpdateLoginModal
                        show={opened == 'UpdateLoginModal'}
                        onHide={(e, r) => this._close(e, r)}
                        user={activeUser}/>
                )}
                {activeUser && activeUser._links.find(linkFinder('DisableUser')) && (
                    <DisableUserModal
                        show={opened == 'DisableUserModal'}
                        onHide={(e, r) => this._close(e, r)}
                        user={activeUser}/>
                )}
                {activeUser && activeUser._links.find(linkFinder(['AssociateUserWithAgency', 'DissociateUserFromAgency'])) && (
                    <AssociateDissociateUserFromAgencyModal
                        show={opened == 'AssociateDissociateUserFromAgencyModal'}
                        onHide={(e, r) => this._close(e, r)}
                        user={activeUser}/>
                )}
                {activeUser && activeUser._links.find(linkFinder(['AssociateUserWithPatrimony', 'DissociateUserFromPatrimony'])) && (
                    <AssociateDissociateUserFromPatrimonyModal
                        show={opened == 'AssociateDissociateUserFromPatrimonyModal'}
                        onHide={(e, r) => this._close(e, r)}
                        user={activeUser}/>
                )}
                {activeUser && activeUser._links.find(linkFinder('DowngradeExecutiveToPatrimonyManager')) && (
                    <DowngradeExecutiveToPatrimonyManagerModal
                        show={opened == 'DowngradeExecutiveToPatrimonyManagerModal'}
                        onHide={(e, r) => this._close(e, r)}
                        user={activeUser}/>
                )}
        	</div>
        )
    }
}

UserStream = connect((state) => ({
    stream: state.company.user.stream,
    range: state.company.user.range
}))(UserStream)

export default UserStream


// WEBPACK FOOTER //
// ./lib/company/components/UserStream.js